import { render, staticRenderFns } from "./ElementScaleTypeTableColumn.vue?vue&type=template&id=190ce8ae"
import script from "./ElementScaleTypeTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScaleTypeTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports